export const safeStorage = {
  get(key: string): string | null {
    try { return localStorage.getItem(key); } catch { return null; }
  },
  set(key: string, val: string): void {
    try { localStorage.setItem(key, val); } catch (e) { console.warn('LS unavailable', e); }
  },
  remove(key: string): void {
    try { localStorage.removeItem(key); } catch (e) { console.warn('LS unavailable', e); }
  },
};

export const safeSession = {
  get(key: string): string | null {
    try { return sessionStorage.getItem(key); } catch { return null; }
  },
  set(key: string, val: string): void {
    try { sessionStorage.setItem(key, val); } catch (e) { console.warn('SS unavailable', e); }
  },
  remove(key: string): void {
    try { sessionStorage.removeItem(key); } catch (e) { console.warn('SS unavailable', e); }
  },
};
